import { TranslationObject } from '../i18n/translation';

const translations: TranslationObject = {
  title: {
    id: 'pagenotfound.title',
    nb: 'Siden eksisterer ikke',
    en: 'Page not found',
  },
  subtitle: {
    id: 'pagenotfound.subtitle',
    nb: 'Fant ikke siden du leter etter',
    en: "The page you're looking for does not exist",
  },
  errorTitle: {
    id: 'pagenotfound.errorTitle',
    nb: 'Ukjent blindpunkt.',
    en: 'Page not found',
  },
  errorMessage: {
    id: 'pagenotfound.errorMessage',
    nb: 'Siden du leter etter eksisterer ikke, eller du mangler tilgang. Det kan være at du feilstavet nettadressen eller at siden ble flyttet på.',
    en: "The page you're looking for does not exist, or you lack required access. You may have mistyped the address or the page may have moved.",
  },
  linkToDashboard: {
    id: 'pagenotfound.linkToDashboard',
    nb: 'Gå til dashboard',
    en: 'Go to Dashboard',
  },
};

export default translations;
